motifValidator.$inject = ['validator', 'validationHelper'];

export default function motifValidator(validator, validationHelper) {
    const instance = new validator();
    instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    instance.ruleFor('libelle').lengthBetweenValues(0, 200).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');

    return instance;
}
